import React, { Component } from "react";
import { LEGACY_API } from "../../shared/constants";

let LEGACY_API_URL = LEGACY_API.replace("-hmg", ""); // Deixei assim por enquanto pra testar, já que o hmg não funciona.
class CitySelector extends Component {
	constructor(props) {
		super(props);

		this.state = { open: false, results: [] };
		this.searching = null;

		this.setCity = this.setCity.bind(this);
		this.renderResult = this.renderResult.bind(this);
		this.renderResults = this.renderResults.bind(this);
		this.search = this.search.bind(this);
		this.renderSearch = this.renderSearch.bind(this);
	}

	setCity(origin) {
		this.setState({ results: null, open: false });
		this.props.callback(origin);
	}

	renderResult(result, i) {
		const { city, name, iata } = result;
		const { term } = this.state;
		let str = `${city} - ${name} (${iata})`;
		const reg = new RegExp(`(${term})`, "ig");
		str = str.replace(reg, "<em>$1</em>");

		return (
			<div
				onClick={() => this.setCity(result)}
				key={i}
				className="city-selector__result"
				dangerouslySetInnerHTML={{ __html: str }}
			/>
		);
	}

	renderResults(cities) {
		if (!cities) return null;
		const { filter } = this.props;
		let results = cities;
		if (filter) results = cities.filter(filter);

		return <div className="city-selector__result-group">{results.map(this.renderResult)}</div>;
	}

	search(value) {
		if (value.length < 3) return this.setState({ results: null });
		const that = this;

		const onLoad = function() {
			const { responseText, status } = this;

			if (status == 200) {
				const results = JSON.parse(responseText);
				that.setState({ results, term: value });
			} else {
				console.error("Erro na requisição de aeroportos.");
			}
		};

		let term = encodeURIComponent(value);
		if (this.searching) this.searching.abort();
		this.searching = new XMLHttpRequest();
		this.searching.onload = onLoad;
		this.searching.open("get", `${LEGACY_API_URL}/airports/search/${term}`, true);
		this.searching.send();
	}

	renderSearch() {
		const { open, results } = this.state;
		if (!open) return null;

		return (
			<div className="city-selector__search">
				<button
					className="city-selector__close"
					type="button"
					onClick={() => this.setState({ open: false })}
				>
					Fechar x
				</button>
				<p className="city-selector__text">Pesquise a cidade ou aeroporto de origem:</p>
				<div className="city-selector__input-wrapper">
					<input
						placeholder="Digite a cidade ou aeroporto"
						className="city-selector__input"
						onInput={({ currentTarget: { value } }) => this.search(value)}
						type="text"
						autoFocus
					/>
					<span className="icon icon-search" />
				</div>
				<div className="city-selector__results-wrapper">
					{results && this.renderResults(results)}
				</div>
			</div>
		);
	}

	render() {
		const { selected } = this.props;
		const city = selected ? `${selected.city} (${selected.iata})` : "";

		return (
			<div className="city-selector">
				<div onClick={() => this.setState({ open: true })} className="city-selector__select">
					{city} <span className="icon icon-pin" />
				</div>
				{this.renderSearch()}
			</div>
		);
	}
}

export default CitySelector;
